/* eslint-disable import/export */
/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';

interface IData {
  marginLeft?: number;
  maxChar?: number;
  textAlign?: string;
  percentOne?: string;
  percentTwo?: string;
}

export const BoxCard = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
`;

export const TitleLevel = styled.span`
  display: flex;
  align-items: center;
  font-size: 1em;
  font-weight: 700;
  color: #4f545c;
  margin-bottom: 8px;
`;

export const TitleLevelSmall = styled.span`
  text-align: left;
  font-size: 1em;
  color: #4f545c;
  font-weight: 300;
  padding-bottom: 12px;
  margin-bottom: 8px;
  margin-right: 16px;
  white-space: nowrap;
`;

export const ContainerSlider = styled.div`
  width: 100%;
  height: 8px;
  background-color: #4f545c;
  border-radius: 3px;
  margin-top: 32px;
  margin-bottom: 30px;
  position: relative;

  input[type='range'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    outline: none;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    background-color: transparent;
    pointer-events: none;
  }

  input[type='range']::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    height: 5px;
  }
  input[type='range']::-moz-range-track {
    -moz-appearance: none;
    height: 5px;
  }
  input[type='range']::-ms-track {
    appearance: none;
    height: 5px;
  }
  input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 10px;
    height: 24px;
    background-color: #ffffff;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.6);
    border-radius: 3px;
    cursor: pointer;
    margin-top: -9px;
    pointer-events: auto;
  }
  input[type='range']::-moz-range-thumb {
    -moz-appearance: none;
    width: 10px;
    height: 24px;
    background-color: #ffffff;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.6);
    border-radius: 3px;
    cursor: pointer;
    pointer-events: auto;
  }
  input[type='range']::-ms-thumb {
    appearance: none;
    width: 10px;
    height: 24px;
    background-color: #ffffff;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.6);
    border-radius: 3px;
    cursor: pointer;
    pointer-events: auto;
  }
  input[type='range']:active::-webkit-slider-thumb {
    background-color: #e71037;
  }
`;

export const SliderTrack = styled.div<IData>`
  width: 100%;
  height: 5px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  border-radius: 5px;
`;

export const SliderTrackMetric = styled.div`
  width: 100%;

  .wrapper {
    position: relative;

    .container {
      width: 97%;
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: -8px;
      margin: 0 1.5%;

      .marker {
        width: 2px;
        height: 24px;
        background: #4f545c;
        display: flex;
        justify-content: space-around;
        position: relative;

        sup {
          position: absolute;
          top: -15px;
          font-size: 10px;
          font-weight: 700;
          color: #72767d;
        }
      }
    }
  }
`;

export const Title = styled.h1`
  font-size: 1.2rem;
  font-weight: 700;
  color: #2e3958;
  margin-bottom: 40px;
`;

export const LabelTable = styled.span`
  text-align: left;
  font-size: 1em;
  color: black;
  font-weight: 400;
  white-space: nowrap;
`;

export const CheckBox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  background-color: #fff;
  margin: 0;
  font: inherit;
  color: #a1a1a1;
  width: 1.05em;
  height: 1.05em;
  border: 0.15em solid #a1a1a1;
  border-radius: 0.15em;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;

  &:before {
    content: '';
    width: 0.65em;
    height: 0.65em;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em #e71037;
    transform-origin: center center;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  }
  &:checked:before {
    transform: scale(1);
  }
`;

export const SpanSwitch = styled.span`
  font-size: 14px;
  margin: 5px;
`;

export const MockPhone = styled.div`
  width: 280px;
  height: 560px;
  border-radius: 32px;
  background: #111;
  padding: 12px;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MockPhoneScreen = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 26px;
  overflow: hidden;
  position: relative;
  background: #000;
`;

export const MockPhoneBackground = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const PushCard = styled.div`
  position: absolute;
  top: 18px;
  left: 14px;
  right: 14px;
  background: rgba(255, 255, 255, 0.94);
  border-radius: 14px;
  padding: 12px 12px;
  display: flex;
  gap: 10px;
  align-items: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(6px);
`;

export const PushIcon = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: cover;
`;

export const PushContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const PushTitle = styled.span`
  font-size: 0.9rem;
  font-weight: 700;
  color: #1e2430;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PushText = styled.span`
  font-size: 0.8rem;
  color: #4f545c;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

interface ITabButtonProps {
  $active: boolean;
  $disabled?: boolean;
}

export const TabGroup = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  border-bottom: 1px solid #eceef2;
  padding-bottom: 2px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 0;
    border-bottom: none;
  }
`;

export const TabButton = styled.button<ITabButtonProps>`
  ${({ $active, $disabled }) => css`
    flex: 1;
    min-height: 42px;
    border: none;
    border-radius: 0;
    border-bottom: 2px solid ${$active ? '#e71037' : 'transparent'};
    background: transparent;
    color: #e71037;
    font-size: 0.92rem;
    font-weight: ${$active ? 700 : 500};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    padding: 0 10px;
    cursor: ${$disabled ? 'not-allowed' : 'pointer'};
    transition: color 0.2s ease, border-bottom-color 0.2s ease;
    opacity: ${$disabled ? 0.42 : $active ? 1 : 0.74};
    pointer-events: ${$disabled ? 'none' : 'auto'};

    &:hover {
      opacity: 1;
    }

    svg {
      flex-shrink: 0;
      opacity: inherit;
    }

    @media (max-width: 768px) {
      min-width: 100%;
      border-bottom: 1px solid #f3f4f7;
      padding: 10px 2px;
    }
  `}
`;

export const TabPanel = styled.div`
  width: 100%;
  margin-top: 14px;
  border: none;
  border-radius: 0;
  background: #fff;
  padding: 8px 0 0;
`;

export const TabPanelText = styled.p`
  margin: 0;
  color: #72767d;
  font-size: 0.95rem;
`;
